module.exports = __webpack_public_path__ + "static/media/ET030 new.d7d18de3.jpg";